module.exports = __webpack_public_path__ + "img/alxander.6c971e71.jpg";